/**
 * CitySelector class definition
 *
 * @author caiocosta
 * @date 20/03/15
 */

!function () {
	var CitySelector = function (element, options) {
		this.element = $(element);
		this.options = $.extend({}, CitySelector.defaults, this.element.data(), typeof options == 'object' && options);
		this.init();
	};

	CitySelector.defaults = {
		labelNothingSelected : 'Please select',
		containerClass: 'city-selector',
		buttonClass: 'city-selector__btn',
		buttonLabelClass: 'city-selector__btn-label',
		dropdownClass: 'city-selector__menu',
		groupClass: 'city-selector__group',
		groupLabelClass: 'city-selector__group-label',
		submenuClass: 'city-selector__submenu',
		itemClass: 'city-selector__item',
		linkClass: 'city-selector__link',
		separatorClass: 'city-selector__sep'
	};

	CitySelector.prototype = {
		constructor: CitySelector,

		init: function () {
			// Is this element already a city selector?
			if (this.element.data('citySelector')) {
				//this.refresh();
				return;
			}

			this.items = $();
			this.groups = $();

			this.elementChildren = this.element.find('> *');
			this.elementDefaultItem = this.elementChildren.filter(function () {
				return ($(this).prop('tagName').toLowerCase() == 'option' && !$(this).attr('value'));
			});

			if (this.elementDefaultItem.length) {
				this.options = $.extend({}, this.options, {labelNothingSelected: this.elementDefaultItem.text()});
			}

			this.createContainer()
				.createButton()
				.createDropdown()
				.registerListeners()
				.addSeparators()
				.updateSelectedItem()
				.hideElement();

			this.element.data('citySelector', this);
		},

		hideElement: function () {
			this.element.hide();
		},

		createContainer: function () {
			this.container = $('<div class="' + this.options.containerClass + '"/>');
			this.container.insertAfter(this.element);
			return this;
		},

		createButton: function () {
			this.button = $('<button type="button" class="' + this.options.buttonClass + '"><span class="' + this.options.buttonLabelClass + '">' + this.options.labelNothingSelected + '</span></button>');
			this.button.append($('<i class="caret"/>'))
			this.button.appendTo(this.container);
			return this;
		},

		createDropdown: function () {
			var that = this;

			this.dropdown = $('<ul class="' + this.options.dropdownClass + ' dropdown-menu"/>');

			this.elementChildren.not(this.elementDefaultItem).each(function () {
				var element;

				if ($(this).prop('tagName').toLowerCase() == 'optgroup') {
					element = that.createGroupElement($(this));
					that.groups = that.groups.add(element);
					that.items = that.items.add(element.find('.' + that.options.itemClass));
				}
				else {
					element = that.createItemElement($(this));
					that.items = that.items.add(element);
				}

				element.appendTo(that.dropdown);
			});

			this.dropdown.appendTo(this.container);

			return this;
		},

		createGroupElement: function (group) {
			var that = this;
			var label = group.attr('label');
			var groupItem = $('<li class="' + this.options.groupClass + ' ' + (group.attr('class') || '') + '"/>');
			var groupLabel = $('<a href="#" class="' + this.options.groupLabelClass + '">' + label + '</a>');
			var firstSubmenu = $('<ul class="' + this.options.submenuClass + ' ' + this.options.submenuClass + '--col-1" data-group="' + this.sanitizeString(label) + '"/>');
			var secondSubmenu = $('<ul class="' + this.options.submenuClass + ' ' + this.options.submenuClass + '--col-2" data-group="' + this.sanitizeString(label) + '"/>');
			var submenuItems = group.find('option');

			submenuItems.each(function () {
				var menuToAppendTo = null;
				if ($(this).index() < Math.ceil(submenuItems.length / 2)) {
					menuToAppendTo = firstSubmenu;
				}
				else {
					menuToAppendTo = secondSubmenu;
				}

				that.createItemElement($(this)).appendTo(menuToAppendTo);
			});

			groupLabel.add(firstSubmenu).add(secondSubmenu).appendTo(groupItem);

			return groupItem;
		},

		createItemElement: function (item) {
			var li = $('<li class="' + this.options.itemClass + '" data-value="' + item.val() + '"/>');
			var link = $('<a href="' + item.val() + '" class="' + this.options.linkClass + ' ' + item.attr('class') + '"></a>');

			link.html(item.html());

			link.appendTo(li);

			return li;
		},

		registerListeners: function () {
			var that = this;

			this.element.on('change.city-selector.button', function () {
				that.updateSelectedItem();
			});

			this.button.on('click.city-selector.button', function () {
				that.toggleDropdown();

				return false;
			});

			this.items.find('.' + this.options.linkClass).on('click.city-selector.link', function () {
				that.element.val($(this).parent().data('value'));

				that.element.trigger('change');

				that.closeDropdown();

				return false;
			});

			this.groups.on('click.city-selector.group', function () {
				that.toggleGroup($(this)).closeAllGroupsExcept($(this));

				return false;
			});

			$('html').on('click.city-selector.outside', function(element) {
				if ($(element.target).closest(that.container).length < 1) {
					that.closeDropdown();
				}
			});

			return this;
		},

		openDropdown: function () {
			this.container.addClass('open');

			this.dropdown.css({
				'top': this.button.outerHeight()
			});

			if (this.getActiveGroup()) {
				this.openGroup(this.getActiveGroup());
			}
		},

		closeDropdown: function () {
			this.closeAllGroups();

			this.container.removeClass('open');
		},

		toggleDropdown: function () {
			if (this.container.hasClass('open')) {
				this.closeDropdown();
			}
			else {
				this.openDropdown();
			}
		},

		openGroup: function (group) {
			group.addClass('open');

			group.find('.' + this.options.submenuClass).css({
				'top': group.prevAll('.' + this.options.separatorClass).last().position().top
			});

			var groups = group.add(group.prevUntil('.' + this.options.separatorClass).add(group.nextUntil('.' + this.options.separatorClass)));

			var firstColumnHeight = 0;
			var secondColumnHeight = 0;

			var groupsHeight = groups.length * groups.outerHeight();

			var firstColumnItems = group.find('.' + this.options.submenuClass + '--col-1 .' + this.options.itemClass);
			var secondColumnItems = group.find('.' + this.options.submenuClass + '--col-2 .' + this.options.itemClass);

			firstColumnItems.each(function () {
				firstColumnHeight += $(this).outerHeight();
			});

			secondColumnItems.each(function () {
				secondColumnHeight += $(this).outerHeight();
			});

			var separatorHeight = Math.max(0, (firstColumnHeight - groupsHeight), (secondColumnHeight - groupsHeight));

			var submenuHeight = Math.max(firstColumnHeight, secondColumnHeight, groupsHeight) + 1;

			group.nextAll('.' + this.options.separatorClass).last().height(separatorHeight);

			group.find('.' + this.options.submenuClass).height(submenuHeight);

			this.container.addClass('group-open');

			this.updateDropdownPosition();

			return this;
		},

		closeGroup: function (group) {
			group.removeClass('open');

			if (this.groups.filter('.open').length == 0) {
				this.container.removeClass('group-open');

				group.nextAll('.' + this.options.separatorClass).last().height(0);
			}

			return this;
		},

		toggleGroup: function (group) {
			if (group.hasClass('open')) {
				this.closeGroup(group);
			}
			else {
				this.openGroup(group);
			}

			return this;
		},

		closeAllGroups: function () {
			var that = this;

			this.groups.each(function () {
				that.closeGroup($(this));
			});

			return this;
		},

		closeAllGroupsExcept: function (group) {
			var that = this;

			this.groups.not(group).each(function () {
				that.closeGroup($(this));
			});

			return this;
		},

		addSeparators: function () {
			var that = this;

			$('<li class="' + that.options.separatorClass + '">').insertAfter(this.groups.prev('.' + that.options.itemClass));
			$('<li class="' + that.options.separatorClass + '">').insertBefore(this.groups.next('.' + that.options.itemClass));

			return this;
		},

		sanitizeString: function (string) {
			return string.replace(/[^\w\s]/gi, '').replace(/\s/gi, '-').toLowerCase();
		},

		updateSelectedItem: function () {
			this.button.find('.' + this.options.buttonLabelClass).html(this.element.find('option:selected').html());

			this.items.removeClass('selected');

			this.container.find('[data-value="' + this.element.val() + '"]').addClass('selected');

			return this;
		},

		updateDropdownPosition: function () {
			var rightPosition = this.container.offset().left + this.dropdown.outerWidth();

			if (rightPosition > $(window).width()) {
				this.container.addClass('right');
			}
			else {
				this.container.removeClass('right');
			}
		},


		/**
		 * Getters & Setters
		 */

		getActiveGroup: function () {
			var selectedItemGroup = this.container.find('.selected').closest('.' + this.options.groupClass);
			return ((selectedItemGroup.length > 0) ? selectedItemGroup : false);
		}
	};

	$.fn.citySelector = function (options) {
		return this.each(function () {
			new CitySelector(this, options);
		});
	}
}();
